import { combineReducers } from "redux";
import SettingReducer from "./setting/reducers";
import RulesReducer from "./rule/reducers";
import RegistrationSaga from "./registration/reducers";
import UserInfoSaga from "./user/reducers";

const rootReducer = combineReducers({
  SettingReducer,
  RulesReducer,
  RegistrationSaga,
  UserInfoSaga,
});

export default rootReducer;
